<h2 mat-dialog-title>Progress reports — {{ data.studentName }}</h2>

<mat-dialog-content class="mat-typography">
  @if (loading) {
    <p class="font-slategrey">Loading…</p>
  } @else if (reports.length === 0) {
    <p class="font-slategrey">No progress reports yet.</p>
  } @else {
    <ul class="pr-tiles">
      @for (report of reports; track report.id) {
        <li class="pr-tile" (click)="select(report)">
          <span class="pr-tile__date">{{ report.createdDate | date:'dd/MM/yyyy' }}</span>
          <span class="pr-tile__tags">
            @if (statusLabel(report.statusId)) {
              <span class="badge badge-pill pr-status" [ngClass]="statusClass(report.statusId)">
                {{ statusLabel(report.statusId) }}
              </span>
            }
          </span>
        </li>
      }
    </ul>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>
